export const NavigationIcons = Object.freeze({
    ACCOUNTS: 'EnIconAccounts',
    CUSTOMER: 'EnIconCustomer',
    DASHBOARD: 'EnIconDashboard',
    DEVELOPMENT: 'EnIconDevelopment',
    ENCOUNT: 'EnIconEnCount',
    ENFLOW: 'EnIconEnFlow',
    ENTAB: 'EnIconEnTab',
    LOGOUT: 'EnIconLogout',
    OTHER: 'EnIconOther',
    RENTALDATA: 'EnIconRentalData',
    TOOLS: 'EnIconTools',
    USER: 'EnIconUser',
});